import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=11def810&scoped=true&"
import script from "./BaseWidget.vue?vue&type=script&lang=js&"
export * from "./BaseWidget.vue?vue&type=script&lang=js&"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&id=11def810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11def810",
  null
  
)

export default component.exports